"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getConfigByEnv = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const configs = {
  default: {
    CURRENT_ENV: process.env.NODE_ENV || 'development',
    SOCKET_ROLLBAR_TOKEN: 'f8ab9c054cf24458b2f755bd9c4ab446'
  },
  staging: {
    SOCKET_URL: 'https://socket-staging.neat.com'
  },
  qa: {
    SOCKET_URL: 'https://socket-qa.neat.com'
  },
  production: {
    SOCKET_URL: 'https://socket.neat.com'
  },
  test: {
    SOCKET_URL: 'https://socket-staging.neat.com'
  },
  development: {
    SOCKET_URL: 'https://socket-staging.neat.com'
  }
};

const getConfigByEnv = env => _objectSpread({}, configs[env]);

exports.getConfigByEnv = getConfigByEnv;

var _default = _objectSpread(_objectSpread({}, configs.default), configs[process.env.NODE_ENV || 'development'] || {});

exports.default = _default;
//# sourceMappingURL=config.js.map